// extracted by mini-css-extract-plugin
export default {"gradient":"Headline_gradient__9q8un","headline":"Headline_headline__1aKb-","title":"Headline_title__Gx4aa"};